import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_AGENCY_TEAM_CALLOUT,
  PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY,
  PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY,
} from "../../../i18n/keysTranslations";
import {
  AGENCY_TEAM_FAMILIARITY_OPTIONS,
  mapTranslatedOptions,
} from "../agencyFormConfig";
import CalloutBox from "../components/CalloutBox";
import RadioFieldBlock from "../components/RadioFieldBlock";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const AgencyTeamSection = ({ control, readOnly }) => {
  const { t } = useTranslation();
  const familiarityOptions = useMemo(
    () => mapTranslatedOptions({ options: AGENCY_TEAM_FAMILIARITY_OPTIONS, t }),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <RadioFieldBlock
        name="teamFamiliarity"
        label={t(PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY)}
        hint={t(PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY)}
        required
        options={familiarityOptions}
        control={control}
        readOnly={readOnly}
      />
      {readOnly ? null : (
        <CalloutBox sx={{ gridColumn: "1 / -1" }}>
          {t(PRE_ACTIVATION_AGENCY_TEAM_CALLOUT)}
        </CalloutBox>
      )}
    </ReadOnlySectionGrid>
  );
};

export default AgencyTeamSection;
